import { CloseOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { Button, Card, Col, Form, FormInstance, Input, Modal, Row, Tooltip } from "antd";
import React, { useEffect } from "react";
import { IAuditoria } from "../Interfaces/DadosPrevicInterfaces";
import dayjs from "dayjs";

interface IProps {
    form: FormInstance<any>;
    registroHistorico: IAuditoria | undefined,
}

const InfoHistorico = ({ registroHistorico, form }: IProps) => {

    const [exibirModalEventos, setExibirModalEventos] = React.useState<boolean>(false);
    const [audSelected, setAudSelected] = React.useState<IAuditoria>();


    const showModalEventos = (aud: IAuditoria | undefined) => {
        console.log(aud);
        setAudSelected(aud);
        setExibirModalEventos(true);
    };

    useEffect(() => {
        setAudSelected(registroHistorico);
        form?.setFieldsValue({
            dataEvento: registroHistorico?.dtPos && registroHistorico.dtPos !== "" ? dayjs(registroHistorico.dtPos).format("DD/MM/YYYY HH:mm:ss") : "",
            dataOriginal: registroHistorico?.dtPre && registroHistorico.dtPre !== "" ? dayjs(registroHistorico.dtPre).format("DD/MM/YYYY HH:mm:ss") : "",
            origem: registroHistorico?.tpUsuarioPos,
            user: registroHistorico?.usuarioPos
        });
    }, [registroHistorico])

    return (
        <>
            <Card title="Informações do Histórico" style={{ backgroundColor: "#607d8b" }}>
                <Row>
                    <Col xs={24} xl={4}>
                        <Form.Item label="Data do Evento"
                            labelCol={{ span: 24 }}
                            name="dataEvento"
                            colon={false}
                        >
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col xs={24} xl={4}>
                        <Form.Item label="Data do Registro"
                            labelCol={{ span: 24 }}
                            name="dataOriginal"
                            colon={false}
                        >
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col xs={24} xl={8}>
                        <Form.Item label="Evento"
                            labelCol={{ span: 24 }}
                            name="evento"
                            colon={false}
                        >
                            <>
                                {registroHistorico && registroHistorico.eventos && registroHistorico.eventos.length === 1
                                    ? registroHistorico.eventos[0]
                                    : registroHistorico && registroHistorico.eventos && registroHistorico.eventos.length > 1
                                        ?
                                        <>
                                            <Tooltip title="Clique para ver todos os eventos associados">
                                                <UnorderedListOutlined onClick={() => showModalEventos(registroHistorico)} />
                                            </Tooltip>
                                        </>
                                        : "Histórico carregado de forma incompleta. Consulte o registro novamente"
                                }
                            </>
                        </Form.Item>
                    </Col>

                    <Col xs={24} xl={4}>
                        <Form.Item label="Origem"
                            labelCol={{ span: 24 }}
                            name="origem"
                            colon={false}
                        >
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col xs={24} xl={4}>
                        <Form.Item label="Usuário"
                            labelCol={{ span: 24 }}
                            name="user"
                            colon={false}
                        >
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                </Row>
            </Card>

            <Modal
                title={<p>Eventos do Histórico</p>}
                style={{ top: 20 }}
                destroyOnHidden={true}
                // width={500}
                closable={false}
                footer={[
                    <Button icon={<CloseOutlined />} shape="round" key="cancelFechar" onClick={() => setExibirModalEventos(false)}>
                        Fechar
                    </Button>,
                ]}
                open={exibirModalEventos}
            >

                {audSelected?.eventos?.map((evento: string) => (
                    <React.Fragment key={evento}>
                        {evento}
                        <br />
                    </React.Fragment>
                ))}
            </Modal>
        </>
    );
};

export default InfoHistorico;
